import type { Dispatch, AnyAction } from 'redux';

import * as BulkUpsertMaterialCostAPI from 'ab-api/web/materialCost/bulkUpsert';
import * as FindForMaterialAPI from 'ab-api/web/materialCost/findForMaterial';
import * as FindForWorkSummaryAPI from 'ab-api/web/materialCost/findForWorkSummary';
import * as RemoveScheduledCostForMaterialAPI from 'ab-api/web/materialCost/removeScheduledCostForMaterial';
import * as UpsertMaterialCostAPI from 'ab-api/web/materialCost/upsert';

import type { GetRootState } from 'af-reducers';

import { errorHandler } from 'af-utils/actions.util';
import { http } from 'af-utils/http.util';

export function upsertMaterialCost(materialId: number, materialCost: UpsertMaterialCostAPI.W_MaterialCost_Upsert_RM) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {

		const action = async () => {
			return await http.put<UpsertMaterialCostAPI.W_MaterialCost_Upsert_VM>(UpsertMaterialCostAPI.URL(materialId), materialCost);
		};

		return await errorHandler(action, dispatch, redirectTo);
	};
}

export function bulkUpsertMaterialCost(data: BulkUpsertMaterialCostAPI.W_MaterialCost_BulkUpsert_RM) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {

		const action = async () => {
			return await http.put<void>(BulkUpsertMaterialCostAPI.URL(), data);
		};

		return await errorHandler(action, dispatch, redirectTo);
	};
}

export function findForMaterial(materialId: number) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {

		const action = async () => {
			return await http.get<FindForMaterialAPI.W_MaterialCostHistory_FindForMaterial_VM>(FindForMaterialAPI.URL(materialId));
		};

		return await errorHandler(action, dispatch, redirectTo);
	};
}

export function findForWorkSummary(fieldReportId: number, subJobId: number, billableWorkId: number) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {

		const action = async () => {
			return await http.get<FindForWorkSummaryAPI.W_MaterialCost_FindForWorkSummary_VM>(
				FindForWorkSummaryAPI.URL(fieldReportId, subJobId, billableWorkId)
			);
		};

		return await errorHandler(action, dispatch, redirectTo);
	};
}

export function removeScheduledCostForMaterial(materialId: number) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {

		const action = async () => {
			return await http.delete(RemoveScheduledCostForMaterialAPI.URL(materialId));
		};

		return await errorHandler(action, dispatch, redirectTo);
	};
}
